import React from "react";
import Description from "./Description";
import "./Mission-Goals.css";

function Mission() {
  return (
    <div>
      <Description title="Our Mission" text="At Soul Plates, our mission is deeply rooted in the belief that every
          individual, regardless of their background, deserves the opportunity
          to thrive and build a better future. We are dedicated to providing
          shelter, food, and education to all people who are in vulnerable
          situations, offering them a safe heaven where they can rebuild their
          lives. " imagen="https://www.score.org/sites/default/files/styles/responsive_16_9_1000w/public/GettyImages-621904294_1.jpg"
          descripImg="description component img"/>
    </div>
  );
}

export default Mission;
